webpackJsonp([214960607037312],{

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SEO = __webpack_require__(21);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _pageModule = __webpack_require__(35);
	
	var _pageModule2 = _interopRequireDefault(_pageModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        "div",
	        { className: _pageModule2.default.container },
	        _react2.default.createElement(_SEO2.default, { title: "Subscribe | A-Town FM" }),
	        _react2.default.createElement(
	            "h1",
	            null,
	            "Subscribe"
	        ),
	        _react2.default.createElement(
	            "p",
	            null,
	            "A-Town FM is available wherever you listen to podcasts.  Just search \"A-Town FM\" and look for the green tower!"
	        ),
	        _react2.default.createElement(
	            "p",
	            null,
	            "You can also subscribe directly below:"
	        ),
	        _react2.default.createElement(
	            "ul",
	            null,
	            _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                    "a",
	                    { href: "http://podcast.atownfm.com/" },
	                    "RSS"
	                )
	            ),
	            _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                    "a",
	                    { href: "https://itunes.apple.com/us/podcast/a-town-fm/id1257353761?mt=2" },
	                    "Apple Podcast"
	                )
	            ),
	            _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                    "a",
	                    { href: "https://playmusic.app.goo.gl/?ibi=com.google.PlayMusic&isi=691797987&ius=googleplaymusic&apn=com.google.android.music&link=https://play.google.com/music/m/Iulmtptxmmizbms4xepnxmxpujy?t%3DA-Town_FM%26pcampaignid%3DMKT-na-all-co-pr-mu-pod-16" },
	                    "Google Play"
	                )
	            ),
	            _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                    "a",
	                    { href: "https://overcast.fm/itunes1257353761/a-town-fm" },
	                    "Overcast"
	                )
	            ),
	            _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                    "a",
	                    { href: "https://castro.fm/itunes/1257353761" },
	                    "Castro"
	                )
	            ),
	            _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                    "a",
	                    { href: "http://pca.st/WbDg" },
	                    "Pocket Casts"
	                )
	            ),
	            _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                    "a",
	                    { href: "https://player.fm/series/a-town-fm-1910489" },
	                    "PlayerFM"
	                )
	            ),
	            _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                    "a",
	                    { href: "https://radiopublic.com/atown-fm-G1VEZ4" },
	                    "RadioPublic"
	                )
	            )
	        )
	    );
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-subscribe-js-93a32ff5bda53f77d931.js